<template>
    <el-drawer
        title="添加题目"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="80%"
        :before-close="close">
        <div class="panel fx-g1">
            <div class="panel_head fx fx-m_between fx-c_start">
                <el-form :inline="true" :model="form" >
                    <el-form-item label="关键词">
                        <el-input v-model="form.keywords" clearable placeholder="关键词"></el-input>
                    </el-form-item>
                    <el-form-item label="分类">
                        <el-select v-model="form.categoryId" clearable placeholder="分类">
                            <el-option
                                v-for="item in trainCategorys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-cascader placeholder="任务知识点筛选"
                        v-model="form.knowledgeIds"
                        :options="options"
                        :props="{expandTrigger: 'hover'}"
                        @change="handleChange"
                        style="width: 300px;" clearable
                    >
                    </el-cascader>
                        <!-- <el-form-item label="标签">
                        <el-select v-model="form.tagId" clearable placeholder="标签">
                            <el-option
                                v-for="item in trainTags"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
            </div>
            <div class="panel_body">
                <el-table
                    ref="libTable"
                    :data="tableData"
                    stripe
                    style="width: 100%;overflow: auto"
                    @selection-change="handleChoose"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        prop="questionFormHtml"
                        label="题目" >
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        prop="categoryName"
                        label="分类" >
                    </el-table-column>
                    <el-table-column
                        min-width="120"
                        prop="optName"
                        label="语言类型" >
                    </el-table-column>
                    <el-table-column property="date" label="知识点" min-width="250">
                        <template slot-scope="scope">
                            <tag-group :tags="scope.row.knowledgeArray" size="medium"></tag-group>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="120"
                        label="标签">
                        <template slot-scope="scope">
                            <tag-group :tags="scope.row.tagNames"></tag-group>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        prop="typeName"
                        label="类型" >
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        prop="answer"
                        label="答案" >
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        prop="difficulty"
                        label="难度" >
                    </el-table-column>
                </el-table>
            </div>
            <div class="panel_foot fx fx-m_end fx-c_center">
                <el-pagination
                    :background="true"
                    prev-text="上一页"
                    next-text="下一页"
                    layout="prev, pager, next"
                    :current-page="pager.currentPage"
                    :page-size="pager.pageSize"
                    :total="pager.dataTotal"
                    @current-change="pageChange"
                >
                </el-pagination>
            </div>
            <span  class="fx fx-center">
                <el-button type="primary" @click="sub()" :disabled="enable">添 加</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </div>
    </el-drawer>
</template>

<style scoped>
.no_set {
    width: 55px;
    text-align: center;
}
.task_info{
    height: 40px;
    font-size: 12px;
    border-top: 1px solid var(--border);
}
.task_info:first-child{
    border-top: none;
}
.task_info .el-link {
    color: #f29100;
}
.lesson_info i.iconfont,.task_info i.iconfont {
    vertical-align: text-top;
}
.task_info > span {
    margin-right: 30px;
}
</style>


<script>

    export default {
        props: [
            "item"
        ],
        components: {
        },
        data() {
            return {
                show: false,
                needRefreshParent: false,
                form: {
                    keywords: "",
                    enable: true,
                    categoryId:"",
                    ...this.item
                },
                tableData: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                choosedList: [],
                trainCategorys:[],
                trainTags:[],
                options: [],
                enable:false,
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },
        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {

                    this.$emit("close");
                }
            },
            sub() {
                if (this.choosedList.length == 0) {
                    this.$showError("请选择后再操作");
                    return;
                } else {
                    this.enable = true;
                    let trainQuestions = this.choosedList.map(item => {
                        return {
                            id: item.id,
                        }
                    })
                    this.$ajaxPost("/trainQuestionLink/addTrainQuestionLink", {
                        trainModuleId: this.form.id,
                        list: trainQuestions
                    }, data => {
                        this.$showSuccess("保存成功", 1200, ()=>{
                            this.loadData();
                            this.enable = false;
                            this.needRefreshParent = true;
                            this.$emit("submit");
                        });

                    })
                }
                return false;
            },
            handleChoose(val) {
                this.choosedList = val;
            },
            loadData() {
                let data = {"keywords": this.form.keywords,"type": this.form.type,"optType": this.form.optType,"categoryId":this.form.categoryId,"knowledgeIds":this.form.knowledgeIds};
                this.$ajaxPost("/trainQuestion/getTrainQuestion", {
                    form: data,
                    trainModuleId: this.form.id,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadTrainCategory() {
                this.$ajaxGet("/trainCategory/listOptionByAll/1", (data) => {
                     this.trainCategorys = data.result;
                })
            },
            loadTrainTag() {
                this.$ajaxGet("/trainCategory/listOptionByAll/2", (data) => {
                     this.trainTags = data.result;
                })
            },
            handleChange(value) {
                console.log(value);
            },
            loadFuncs() {
                let datas = {"type": this.form.optType};
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:datas} , (data) => {//knowledgeTree
                    this.options = data.result;
                })
            }

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadData();
            this.loadTrainCategory();
            //this.loadTrainTag();
            this.loadFuncs();
        }


    }
</script>
